import { type Instance } from 'tippy.js';

export const tippyPopoverPlugin = {
  name: 'popover',
  fn(instance: Instance) {
    return {
      onMount() {
        instance.popper.setAttribute('popover', 'manual');
        instance.popper.showPopover?.();
      },
    };
  },
};
